// JavaScript code for flypress/breadcrumbs component
(($) => {

     "use strict";
     console.log("flypress/breadcrumbs scripts loaded...");

})(jQuery);